import { createSelector } from '@reduxjs/toolkit';

const codeListsState = (state) => state.codeLists;

export const loadingPrerequisites = createSelector([codeListsState], (codeListsState) => codeListsState.loading);
